'use client';
import React, { useRef, useState, useEffect } from 'react';
import data from '../../data/portfolios/works1';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

function Portfolio() {
  const marquess = ['BUILT','WITH','NARRATIVE']; // Replace with your actual array
  const AllMarquess = Array(10).fill(marquess).flat();
  const swiperRef = useRef(null);
  const [autoplayEnabled, setAutoplayEnabled] = useState(true);
  const sectionRef = useRef(null);

  // Add effect to restore the ID after page has loaded
  useEffect(() => {
    // Wait until page has fully loaded and initial scroll position is set
    const timer = setTimeout(() => {
      if (sectionRef.current) {
        sectionRef.current.id = "portfolio";
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleSlideClick = () => {
    if (swiperRef.current && swiperRef.current.autoplay) {
      swiperRef.current.autoplay.stop();
      setAutoplayEnabled(false);
    }
  };
  
  const swiperOptions = {
    modules: [Pagination, Navigation, Autoplay],
    slidesPerView: 'auto',
    spaceBetween: 80,
    loop: true,
    touchRatio: 0.2,
    speed: autoplayEnabled ? 6000 : 1500, // Return to original speed when user controls slider
    autoplay: autoplayEnabled ? {
      delay: 0, // No delay between transitions for continuous movement
      disableOnInteraction: true, // Completely disable autoplay on any user interaction
    } : false,
    pagination: {
      el: '.work-crev .swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.work-crev .swiper-button-next',
      prevEl: '.work-crev .swiper-button-prev',
    },
    onSwiper: (swiper) => {
      swiperRef.current = swiper;
    },
    on: {
      touchStart: () => {
        // Disable autoplay when user touches/drags slider
        if (autoplayEnabled && swiperRef.current) {
          swiperRef.current.autoplay.stop();
          setAutoplayEnabled(false);
        }
      },
      navigationNext: () => {
        // Disable autoplay when user clicks navigation buttons
        if (autoplayEnabled && swiperRef.current) {
          swiperRef.current.autoplay.stop();
          setAutoplayEnabled(false);
        }
      },
      navigationPrev: () => {
        // Disable autoplay when user clicks navigation buttons
        if (autoplayEnabled && swiperRef.current) {
          swiperRef.current.autoplay.stop();
          setAutoplayEnabled(false);
        }
      }
    }
  };
  return (
    <section ref={sectionRef} className="work-fade section-padding sub-bg bord-top-grd bord-bottom-grd" data-section="portfolio">
      <div className="container position-re">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div>
              <span className="sub-title main-color mb-5">The clarity your brand deserves</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                  Selected <span className="fw-200">Works.</span>
                </span>
              </h3>
            </div>
            <div className="ml-auto vi-more">
              <a
                href="/brands/new"
                className="butn butn-sm butn-bord radius-30"
              >
                <span>Create Your Own</span>
              </a>
              <a
                href="/brands/new"
              >
              <span className="icon ti-arrow-top-right"></span>
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-2 d-flex align-items-end">
            <div className="text pb-100">
              <p>
              We turn that idea that is stuck in your head into a real brand that hits. Narrative helps you find the words, story, and strategy to move people - and mean it.
              </p>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="work-swiper">
              <Swiper {...swiperOptions} className="swiper-container">
                {data.map((item, i) => (
                  <SwiperSlide key={i} onClick={handleSlideClick}>
                    <div className="item">
                      <div className="img">
                        <img src={item.img} alt="" className="radius-15" />
                      </div>
                      <div className="cont">
                        <h3>
                          <span className="text sub-bg">
                            {item.title}
                            <span className="shap-left-top">
                              <svg
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-11 h-11"
                              >
                                <path
                                  d="M11 1.54972e-06L0 0L2.38419e-07 11C1.65973e-07 4.92487 4.92487 1.62217e-06 11 1.54972e-06Z"
                                  fill="#141414"
                                ></path>
                              </svg>
                            </span>
                            <span className="shap-right-bottom">
                              <svg
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-11 h-11"
                              >
                                <path
                                  d="M11 1.54972e-06L0 0L2.38419e-07 11C1.65973e-07 4.92487 4.92487 1.62217e-06 11 1.54972e-06Z"
                                  fill="#141414"
                                ></path>
                              </svg>
                            </span>
                          </span>
                          <span className="text sub-bg">
                            {item.subTitle}
                            <span className="shap-left-bottom">
                              <svg
                                viewBox="0 0 11 11"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-11 h-11"
                              >
                                <path
                                  d="M11 1.54972e-06L0 0L2.38419e-07 11C1.65973e-07 4.92487 4.92487 1.62217e-06 11 1.54972e-06Z"
                                  fill="#141414"
                                ></path>
                              </svg>
                            </span>
                          </span>
                        </h3>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
        <div className="swiper-pagination"></div>
      </div>
      <div className="marq-head">
        <div className="main-marq xlrg text-u o-hidden">
          <div className="slide-har st1">
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4>{item}</h4>
                </div>
              ))}
            </div>
            <div className="box">
              {AllMarquess.map((item, i) => (
                <div key={i} className="item">
                  <h4>{item}</h4>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Portfolio;
